module.exports = __webpack_public_path__ + "img/flex-bg-cover.edd7e0c4.svg";